import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.css"; // or include from a CDN
import "./styles/bootstrapCustom.css";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
import { IntlProvider } from "react-intl";
const language = navigator.language.split(/[-_]/)[0];
ReactDOM.render(
  <React.StrictMode>
    <IntlProvider locale={language}>
      <App />
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
